import {
	Paper,
	Step,
	StepLabel,
	Stepper,
	Typography,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { DropzoneArea } from 'material-ui-dropzone';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import QuickModeDownloadButton from 'src/components/QuickModeDownloadButton';
import { IRootState } from 'src/reducers';
import { IMessage } from '../actions/message';
import * as Actions from '../actions/quickModeContens';
import MessageDialog from '../components/MessageDialog';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import Progress from './Progress';
import QuickModeMessageDialog from './QuickModeMessageDialog';

const styles = (theme: Theme) =>
	createStyles({
		container: {
			'-webkit-align-items': 'center',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			padding: '10px ',
		},
		dropzoneInput: {
			background: '#fff',
			borderColor: '#516ecb',
			borderRadius: '8px',
			margin: '20px',
			maxHeight: '105px',
			minHeight: '105px',
			width: '300px',
		},
		icon: {
			display: 'none',
		},
		image_downLoad: {
			'@media (max-width: 1000px)': {
				margin: '20px 40px 20px 20px',
			},
			cursor: 'pointer',
			width: '125px',
		},
		paper: {
			height: 'auto',
			padding: '20px',
			width: '100%',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		stepper: {
			'@media (max-width: 600px)': {
				width: '100%',
			},
			width: '70%',
		},
		text: {
			margin: '0px',
		},
		textContainer: {
			display: 'table-cell',
			height: '100px',
			padding: '30px 10px',
			textAlign: 'center',
			verticalAlign: 'middle',
			width: '300px',
		},
		textStyle: {
			color: '#516ecb',
			fontSize: '25px',
		},
		textStyle_fileName: {
			'-webkit-box-orient': 'vertical',
			'-webkit-line-clamp': '2',
			color: '#516ecb',
			display: '-webkit-box',
			fontSize: '15px',
			overflow: 'hidden',
			textAlign: 'center',
		},
		title: {
			fontWeight: 'bold',
		},
	});

interface ITestProps {
	initFlg: boolean;
}

interface IQuestionError {
	questionId: string;
	errorMessageList: string[];
}

interface IState {
	steps: string[];
	vertical: boolean;
	fileName: string;
	messages: IMessage[];
	openMessageDialog: boolean;
	templateErrorDialog: boolean;
	loading: boolean;
	errorMessage: string[];
	errorQuestionMessage: IQuestionError[];
	downloadImageSrc: string;
}

class QuickModeTest extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			downloadImageSrc: 'light',
			errorMessage: [],
			errorQuestionMessage: [],
			fileName: '',
			loading: false,
			messages: [],
			openMessageDialog: false,
			steps: [i18n.t('QuickModeTest_0000'), i18n.t('QuickModeTest_0001')],
			templateErrorDialog: false,
			vertical: false,
		};
		this.handleResize = this.handleResize.bind(this);
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.mouseOver = this.mouseOver.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
	}
	public componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		if (this.props.initFlg) {
			this.setState({
				fileName: this.props.testFile.fileName,
			});
		} else {
			this.props.saveTest(null, '');
			this.props.saveTemplateData(null);
		}
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	public handleResize() {
		const vertical = document.body.clientWidth < 600;
		this.setState({
			vertical,
		});
	}

	public dropRejected = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
	};

	public drop = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
	};

	public getFileAndValidate = async (files: File[]) => {
		const FileName: string = files[0].name;
		const messages: IMessage[] = [];
		if (!FileName.endsWith('.xlsm')) {
			// アップロードファイルはxlsmのみです。
			const message: IMessage = {
				content: 'LMCM_E_16026',
				replacements: [],
			};
			messages.push(message);
			this.setState({
				messages,
				openMessageDialog: true,
			});
			return;
		}
		this.props.saveTest(files[0], FileName);
		this.setState({
			fileName: FileName,
			loading: true,
		});
		const form = new FormData();
		const modelData = {
			per_quickMode_testTemplateUpload: {
				accessType: '10',
			},
		};
		form.append('file', files[0]);
		form.append('__modelData', JSON.stringify(modelData));
		const request = new XMLHttpRequest();
		request.open(
			'POST',
			Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
			true
		);
		request.setRequestHeader('Accept', 'application/json');
		request.send(form);
		request.onreadystatechange = () => {
			if (request.readyState === 4) {
				if (request.status === 200) {
					this.setState({
						loading: false,
					});
					const resp = JSON.parse(request.responseText);
					if (resp.per_quickMode_testTemplateUpload) {
						if (resp.per_quickMode_testTemplateUpload.errorCode) {
							const message: IMessage = {
								content:
									resp.per_quickMode_testTemplateUpload
										.errorCode,
								replacements: [],
							};
							messages.push(message);
							this.setState({
								fileName: '',
								messages,
								openMessageDialog: true,
							});
							this.props.saveTest(null, '');
							this.props.saveTemplateData(null);
						} else {
							const errorList: string[] =
								resp.per_quickMode_testTemplateUpload.errorList;
							const questionErrorList: IQuestionError[] =
								resp.per_quickMode_testTemplateUpload
									.questionErrorList;
							if (
								errorList.length > 0 ||
								questionErrorList.length > 0
							) {
								this.setState({
									errorMessage: errorList,
									errorQuestionMessage: questionErrorList,
									fileName: '',
									templateErrorDialog: true,
								});
								this.props.saveTest(null, '');
								this.props.saveTemplateData(null);
								return;
							} else {
								const templateData =
									resp.per_quickMode_testTemplateUpload
										.templateModel;
								const isOneQuestionOneAnswer =
									templateData.oneQuestionOneAnswer;
								const numberOfQuestions =
									templateData.numberOfQuestions;
								const passScore = templateData.passScore;
								const questions = templateData.questionList;
								const unAnswering =
									resp.per_quickMode_testTemplateUpload
										.unAnswering;
								const param: Actions.ITestInfo = {
									isOneQuestionOneAnswer,
									numberOfQuestions,
									passScore,
									questions,
									unAnswering,
								};
								this.props.saveTemplateData(param);
							}
						}
					} else if (resp.tsqErrorMessage) {
						const message: IMessage = {
							content: resp.tsqErrorMessage[0].message,
							replacements: resp.tsqErrorMessage[0].strArray,
						};
						messages.push(message);
						this.setState({
							fileName: '',
							messages,
							openMessageDialog: true,
						});
						this.props.saveTest(null, '');
						this.props.saveTemplateData(null);
					}
				}
				this.setState({
					loading: false,
				});
			}
		};
	};

	public render() {
		const { classes } = this.props;
		const DropzoneAreaBaseClasses = {
			icon: classes.icon,
			text: classes.text,
			textContainer: classes.textContainer,
		};

		return (
			<>
				<Paper className={classes.paper}>
					<Progress open={this.state.loading} />
					<Typography
						variant="h6"
						color="primary"
						className={classes.title}
					>
						{i18n.t('QuickModeTest_0002')}
					</Typography>
					<div className={classes.container}>
						<Stepper
							orientation={
								this.state.vertical ? 'vertical' : 'horizontal'
							}
							className={classes.stepper}
						>
							{this.state.steps.map((step, i) => {
								return (
									<Step key={i} active={true}>
										<StepLabel>{step}</StepLabel>
									</Step>
								);
							})}
						</Stepper>
					</div>
					<div className={classes.container}>
						<QuickModeDownloadButton
							imageSrc={require('../images/download_' +
								this.state.downloadImageSrc +
								'.png')}
							path={`${
								process.env.PUBLIC_URL
							}/quickMode/KantanTestTemplate.xlsm`}
							downloadName="KantanTestTemplate.xlsm"
							imageClassName={classes.image_downLoad}
							mouseOver={this.mouseOver}
							mouseLeave={this.mouseLeave}
						/>
						<DropzoneArea
							acceptedFiles={['.xlsm']}
							classes={DropzoneAreaBaseClasses}
							dropzoneText={
								this.state.fileName
									? this.state.fileName
									: 'drop here'
							}
							dropzoneClass={classes.dropzoneInput}
							dropzoneParagraphClass={
								this.state.fileName
									? classes.textStyle_fileName
									: classes.textStyle
							}
							filesLimit={1}
							showAlerts={false}
							showPreviews={false}
							showPreviewsInDropzone={false}
							showFileNamesInPreview={false}
							onDropRejected={this.dropRejected}
							onDrop={this.drop}
						/>
					</div>
				</Paper>
				<MessageDialog
					open={this.state.openMessageDialog}
					showCancelButton={false}
					title={i18n.t('QuickModeTest_0004')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<QuickModeMessageDialog
					open={this.state.templateErrorDialog}
					title={i18n.t('QuickModeTest_0004')}
					errorList={this.state.errorMessage}
					questionErrorList={this.state.errorQuestionMessage}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</>
		);
	}
	protected mouseOver() {
		this.setState({
			downloadImageSrc: 'deep',
		});
	}

	protected mouseLeave() {
		this.setState({
			downloadImageSrc: 'light',
		});
	}

	protected errorMessageDialogClose() {
		this.setState({
			errorMessage: [],
			errorQuestionMessage: [],
			messages: [],
			openMessageDialog: false,
			templateErrorDialog: false,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	testFile: state.quickModeContents.testFile,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	saveTemplateData: (templateData: Actions.ITestInfo | null) => {
		dispatch(Actions.setTestData({ templateData }));
	},
	saveTest: (file: File | null, fileName: string) => {
		dispatch(Actions.setTestFile({ file, fileName }));
	},
});
const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ITestProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeTest);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/QuickModeTest.tsx